<script>
export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  props: {
    coupon: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localCode: '',
    };
  },
};
</script>

<template>
  <div class="card mb-3" v-if="coupon">
    <div class="card-body">

      <!-- Modo editável: sem cupom aplicado -->
      <template v-if="editable && !coupon.applied">
        <h6 class="mb-3">Você possui um cupom de desconto?</h6>
        <b-input-group>
          <b-form-input
            v-model="localCode"
            :disabled="coupon.loading"
            style="text-transform: uppercase;"
            @keyup.enter="$emit('apply', localCode)"
          ></b-form-input>
          <b-input-group-append>
            <button
              class="btn btn-default"
              type="button"
              :disabled="coupon.loading || !localCode"
              v-on:click="$emit('apply', localCode)"
            >
              Aplicar
              <b-spinner v-if="coupon.loading" small class="ml-1 align-middle" variant="white" role="status"></b-spinner>
            </button>
          </b-input-group-append>
        </b-input-group>
      </template>

      <!-- Modo editável: cupom aplicado com botão remover -->
      <template v-else-if="editable && coupon.applied">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p class="mb-1"><strong>{{ coupon.name }}</strong><br><span class="text-muted font-size-13">{{ coupon.code }}</span></p>
            <p class="mb-1 font-size-13 text-muted">{{ coupon.description }}</p>
            <p class="mb-1 font-size-13 text-success">
              Desconto de {{ coupon.discount_value | currency }} no 1º pagamento
            </p>
            <p class="mb-0 font-size-13">
              Valor do 1º pagamento: <strong>{{ coupon.final_value | currency }}</strong>
            </p>
          </div>
          <button class="btn btn-link text-danger" type="button" v-on:click="$emit('remove')">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </template>

      <!-- Modo somente leitura: cupom aplicado sem controles de edição -->
      <template v-else-if="!editable && coupon.applied">
        <div>
          <p class="mb-1"><strong>{{ coupon.name }}</strong><span class="text-muted font-size-13 ml-2">{{ coupon.code }}</span></p>
          <p class="mb-1 font-size-13 text-muted">{{ coupon.description }}</p>
          <p class="mb-1 font-size-13 text-success">
            Desconto de {{ coupon.discount_value | currency }} no 1º pagamento
          </p>
          <p class="mb-0 font-size-13">
            Valor do 1º pagamento: <strong>{{ coupon.final_value | currency }}</strong>
          </p>
        </div>
      </template>

    </div>
  </div>
</template>
